import Navbar from '@/pages/home/components/Navbar';
import Hero from '@/pages/home/components/Hero';
import NoticeTicker from '@/pages/home/components/NoticeTicker';
import TopicWall from '@/pages/home/components/TopicWall';
import FeaturedGossip from '@/pages/home/components/FeaturedGossip';
import ChatLounge from '@/pages/home/components/ChatLounge';
import FanClub from '@/pages/home/components/FanClub';
import HotRanking from '@/pages/home/components/HotRanking';
import DownloadEntry from '@/pages/home/components/DownloadEntry';
import Footer from '@/pages/home/components/Footer';

export default function Home() {
  return (
    <div className="w-full min-h-screen bg-background-50 font-body antialiased">
      <Navbar />
      <main>
        <Hero />
        <NoticeTicker />
        <TopicWall />
        <FeaturedGossip />
        <ChatLounge />
        <FanClub />
        <HotRanking />
        <DownloadEntry />
      </main>
      <Footer />
    </div>
  );
}